import { connect } from 'react-redux';
import mobileUserMessagesManagement from '../../components/Settings/mobileUserMessagesManagement';

function mapStateToProps(state) {
  return {
    currentUser: state.settings.currentUser,
    isLoading: state.settings.userDetailIsLoading,
    error: state.settings.userDetailError,
    userPermissions: state.auth.userPermissions,
  };
}

export default connect(mapStateToProps, {

})(mobileUserMessagesManagement);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/mobileUserMessagesManagement.jsx